import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ children, isAuthenticated, requireAdmin = false, requirePayment = true, user }) => {
  const location = useLocation();
  const [shouldRender, setShouldRender] = useState(() => isAuthenticated || localStorage.getItem('token') !== null);
  
  // Rotas que não precisam de pagamento (checkout, upsell)
  const paymentExemptRoutes = ['/checkout', '/upsell', '/login', '/sales', '/upgrade'];
  const isPaymentExemptRoute = paymentExemptRoutes.some(route => location.pathname.startsWith(route));
  
  // Pequeno delay para evitar flash de redirecionamento
  useEffect(() => {
    // Verificar se temos token no localStorage como fallback
    const hasToken = localStorage.getItem('token') !== null;
    
    if (!isAuthenticated && !hasToken) {
      // Realmente não autenticado
      setShouldRender(true);
    } else {
      // Dar um pequeno tempo para o estado sincronizar
      const timer = setTimeout(() => {
        setShouldRender(true);
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated]);
  
  // Enquanto não confirmamos o estado, não renderizar nada
  if (!shouldRender) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  // Verificar token do localStorage como fallback
  const hasToken = localStorage.getItem('token') !== null;
  
  if (!isAuthenticated && !hasToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (requireAdmin && !user?.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  // Verificar se usuário pagou ou está em trial (exceto para rotas de pagamento e admins)
  if (requirePayment && !isPaymentExemptRoute && !user?.is_admin) {
    const paymentStatus = user?.payment_status;
    const subscriptionPlan = user?.subscription_plan;
    
    // Usuários free_trial com status paid podem acessar
    const isPaid = paymentStatus === 'paid' || paymentStatus === 'active';
    const isFreeTrial = subscriptionPlan === 'free_trial' && isPaid;
    
    // Se trial expirou, redirecionar para upgrade
    if (paymentStatus === 'trial_expired') {
      return <Navigate to="/upgrade" replace />;
    }
    
    if (!isPaid && !isFreeTrial) {
      // Usuário não pagou - redirecionar para checkout
      const plan = user?.selected_plan || user?.subscription_plan || 'starter';
      return <Navigate to={`/checkout?plan=${plan}`} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
